import React from "react";
import { Box, Typography, TextField, Grid } from "@mui/material";
import * as Yup from "yup";
import { useFormik } from "formik";
import BasicModal from "../../components/BasicModal";
import FormModalActions from "../../components/FormModalActions";
import { MEDIUM_FORM_MODAL_SX } from "../../utils/formModalStyles";
import { updateReport } from "../../services/pathLabTestReportService";

// Update the validation schema to ensure result is a positive number
const validationSchema = Yup.object({
  result: Yup.number()
    .typeError("Result must be a number")
    .positive("Result must be a positive number")
    .required("Result is required"),
});

const EditLabTest = ({ open, onClose, lab_report }) => {
  const formik = useFormik({
    initialValues: {
      result: lab_report?.result || "",
      patientId: lab_report?.patientId || "",
      testId: lab_report?.testId || "",
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: async (values) => {
      console.log("Sending update for reportId:", lab_report.reportId);
      console.log("Payload:", values);

      try {
        await updateReport(lab_report.reportId, {
          result: values.result,
          patientId: values.patientId,
          testId: values.testId,
        });
        handelCloseModalState(); // Only close after success
      } catch (error) {
        console.error("Error updating report:", error);
      }
    },
  });

  const handelCloseModalState = () => {
    onClose();
    formik.resetForm();
  };

  // Function to handle input change and restrict to numbers only
  const handleResultChange = (event) => {
    const { value } = event.target;
    // Allow only numbers and prevent negative numbers
    if (/^\d*\.?\d*$/.test(value)) {
      formik.setFieldValue("result", value);
    }
  };

  return (
    <BasicModal
      open={open}
      onClose={handelCloseModalState}
      sx={MEDIUM_FORM_MODAL_SX}
    >
      <Box display="flex" flexDirection="column">
        <Box display="flex" justifyContent="center" alignItems="center">
          <Typography
            variant="h4"
            sx={{ fontSize: "1.5rem", fontWeight: "bold", textAlign: "center", pb: 1.5 }}
          >
            Update Test Result For {lab_report?.patientName}
          </Typography>
        </Box>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                id="result"
                name="result"
                label="Test Result"
                value={formik.values.result}
                // onChange={formik.handleChange}
                onChange={handleResultChange} // Use the new handler
                error={formik.touched.result && Boolean(formik.errors.result)}
                helperText={formik.touched.result && formik.errors.result}
              />
            </Grid>
            <Grid item xs={12}>
              <FormModalActions
                onCancel={handelCloseModalState}
                submitType="submit"
                submitLabel="Update"
                submitDisabled={formik.isSubmitting}
                loading={formik.isSubmitting}
              />
            </Grid>
          </Grid>
        </form>
      </Box>
    </BasicModal>
  );
};

export default EditLabTest;
